import { Navigate, useParams } from 'react-router-dom';
import { IPostVisibility } from '@/redux/post/post.d';
import { useGetProjectGroupByIdQuery } from '@/redux/projectGroup/projectGroup.api.slice';
import { Skeleton } from '@/components/ui/skeleton';
import GroupEditPage from './GroupEditPage';

/**
 * A group still being authored inline is a half-finished wizard run, so it
 * belongs on the wizard's own URL. Everything else — submitted, published, or
 * created by the old flow — edits its metadata here instead of walking every
 * workpiece. Mirrors the backend's own `isUnsubmittedDraft`.
 */
// fallow-ignore-next-line complexity
export default function GroupEditRoute() {
  const { groupId } = useParams();

  const { data: group, isLoading } = useGetProjectGroupByIdQuery(
    // light: the form needs no child attachments, and it still signs the cover
    { id: groupId as string, light: true },
    { skip: !groupId }
  );

  if (isLoading || !group) {
    return (
      <div className="mx-auto max-w-[900px] space-y-5 p-7">
        <Skeleton className="h-10 w-2/3 rounded-lg" />
        <Skeleton className="h-40 w-full rounded-xl" />
        <Skeleton className="h-40 w-full rounded-xl" />
      </div>
    );
  }

  if (
    group.inlineAuthored === true &&
    group.visibility === IPostVisibility.DRAFT
  )
    return <Navigate to={`/project/v2/group/${groupId}`} replace />;

  return <GroupEditPage group={group} />;
}
